import React from 'react';

// A model-generated image URL can encode private text. Never fetch it on render.
export const safeMarkdownComponents = {
  img: ({ src, alt }) => /^https?:\/\//i.test(src || '')
    ? <a href={src} target="_blank" rel="noopener noreferrer">{alt || 'Открыть внешнее изображение'}</a> : <span>{alt || 'Изображение'}</span>,
};
